import React from "react";
import styles from './TutorialsTooltip.module.scss';
import { AiOutlineClose as CloseIcon } from 'react-icons/ai'




const TutorialsTooltip = ({ continuous,
    index,
    step,
    size,
    backProps,
    closeProps,
    primaryProps,
    tooltipProps, isLastStep }) => {

    return (
        <div className={styles.main} {...tooltipProps}>
            <div className={styles.header}>
                <div className={styles.totalSteps}>
                    {`${index + 1}/${size}`}
                </div>
                <div className={styles.closeBtn} {...closeProps}>
                    <CloseIcon />
                </div>
            </div>
            <div className={styles.body}>
                {step.content}
            </div>
            <div className={styles.btnContainer}>
                {index > 0 ? <button className={styles.prevBtn} {...backProps}>
                    Previous
                </button> : null}
                {isLastStep ? <button className={styles.nextBtn} {...closeProps}>
                    Done
                </button> : <button className={styles.nextBtn} {...primaryProps}>
                    Next
                </button>}
            </div>
        </div>
    );
}


export default TutorialsTooltip